import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RegisterSectionSignUpLightReversePattern1 from '../components/sign-up-light-reverse-pattern/RegisterSectionSignUpLightReversePattern1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Register() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <RegisterSectionSignUpLightReversePattern1 />
    </React.Fragment>
  );
}

